import { Api } from 'utils';

class DashboardService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/home/dashboard',params),
	}

}

export default DashboardService;